module.exports = __webpack_public_path__ + "media/img/axis/PP000-adfdd474bc7e6ee927254d318144c261.png";